import React from "react";
import Layout from "../components/Layout";
import SEO from "../components/SEO";

export function Privacy() {
  return (
    <Layout>
      <SEO title="Privacy Policy | Driver Reborn Advisory" description="Privacy Policy for Driver Reborn Fleet Advisory LLC — how visitor information is collected and used." />
      <section className="section">
        <div className="container-narrow">
          <div className="text-[#FF6A00] text-xs uppercase tracking-widest mb-2">Legal</div>
          <h1 className="font-bebas text-5xl uppercase leading-none mb-6" data-testid="privacy-title">Privacy Policy</h1>
          {/* internal reviewer note (not rendered) — Draft pending legal review before public launch. */}
          <div className="space-y-4 text-[#A1A1AA] leading-relaxed">
            <p className="text-sm text-[#E6E6E6]">
              This Privacy Policy is issued by <b>Driver Reborn Fleet Advisory LLC</b> ("Driver Reborn Advisory", "we", "us").
            </p>
            <h2 className="font-bebas text-2xl text-[#E6E6E6] uppercase">What we collect</h2>
            <p>Driver Reborn Advisory collects information that you voluntarily submit through the following surfaces on this site:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Fleet Crossroads Scorecard</li>
              <li>Request form for a 20-Minute Fleet Owner Conversation</li>
              <li>General contact form</li>
              <li>Direct communications you initiate with Driver Reborn Advisory</li>
            </ul>

            <h2 className="font-bebas text-2xl text-[#E6E6E6] uppercase mt-6">How we use it</h2>
            <p>Information you submit is used to understand your business context, prepare a recommendation, and communicate with you about Driver Reborn Advisory services. We do not sell your information.</p>

            <h2 className="font-bebas text-2xl text-[#E6E6E6] uppercase mt-6">Future integrations</h2>
            <p>Driver Reborn Advisory intends to connect this website to a customer relationship management platform in the future. When that integration is activated, the information you submit here may be transmitted to that platform for follow-up. This policy will be updated at that time.</p>

            <h2 className="font-bebas text-2xl text-[#E6E6E6] uppercase mt-6">Systems currently in use</h2>
            <p>This section will be updated as third-party services (analytics, email delivery, payment processors, and marketing platforms) are formally installed and verified. Nothing on this page should be read as a claim that any specific provider is currently in use.</p>

            <h2 className="font-bebas text-2xl text-[#E6E6E6] uppercase mt-6">Your choices</h2>
            <p>You may request access to, correction of, or deletion of your information by submitting a request through the contact form. Response times and specific rights will be finalized during formal legal review.</p>

            <p className="italic mt-8">This draft policy is not legal advice and will be reviewed by counsel before any public launch.</p>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export function Terms() {
  return (
    <Layout>
      <SEO title="Terms and Conditions | Driver Reborn Advisory" description="Terms and Conditions for Driver Reborn Fleet Advisory LLC — general use of this website and services." />
      <section className="section">
        <div className="container-narrow">
          <div className="text-[#FF6A00] text-xs uppercase tracking-widest mb-2">Legal</div>
          <h1 className="font-bebas text-5xl uppercase leading-none mb-6" data-testid="terms-title">Terms and Conditions</h1>
          {/* Internal reviewer note (not rendered): Draft pending legal review before public launch. */}
          <div className="space-y-4 text-[#A1A1AA] leading-relaxed">
            <p className="text-sm text-[#E6E6E6]">
              These Terms are issued by <b>Driver Reborn Fleet Advisory LLC</b> ("Driver Reborn Advisory", "we", "us").
            </p>
            <h2 className="font-bebas text-2xl text-[#E6E6E6] uppercase">Nature of services</h2>
            <p>Driver Reborn Advisory provides educational and business-advisory services intended for owners of established trucking fleets. Information published on this website is general in nature and is not legal, tax, accounting, or financial advice.</p>

            <h2 className="font-bebas text-2xl text-[#E6E6E6] uppercase mt-6">Assessment and application</h2>
            <p>Completing the Fleet Crossroads Scorecard or the Fleet Owner Conversation request does not create a client relationship and does not guarantee acceptance into any Driver Reborn Advisory service. Driver Reborn Advisory may decline any application at its discretion.</p>

            <h2 className="font-bebas text-2xl text-[#E6E6E6] uppercase mt-6">Engagements</h2>
            <p>Specific services, scope, deliverables, pricing, payment terms, timelines, refund provisions, and any performance expectations will be presented in a separate written agreement provided to you before an engagement begins. Nothing on this website constitutes such an agreement.</p>

            <h2 className="font-bebas text-2xl text-[#E6E6E6] uppercase mt-6">Results and outcomes</h2>
            <p>Results are not guaranteed. Any outcome from engaging with Driver Reborn Advisory depends on your business, your data, the decisions you make, your implementation of recommendations, and market conditions outside the parties' control.</p>

            <h2 className="font-bebas text-2xl text-[#E6E6E6] uppercase mt-6">Use of the site</h2>
            <p>You agree to use this website lawfully and not to interfere with its operation. Driver Reborn Advisory may update these terms and the contents of this website at any time.</p>

            <p className="italic mt-8">This draft is not attorney-reviewed and will be finalized by counsel before any public launch.</p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
